import {dealData} from "./pages/deal/deal";
import {SubjectType} from "./enums";

export const isEmpty = (value) => {
  try {
    if (Array.isArray(value) && !value.length)
      return value

    if (!value)
      return true;

    return false
  } catch (e) {
    return false
  }
}

/**
 *
 * @param cadNum
 * @return {boolean}
 */
export const isCadastralNumberValid = (cadNum) => {
  try {
    if (!cadNum)
      return true;

    const regex = new RegExp(/^\d+:\d+:\d+:\d+$/, 'gmi');
    return regex.test(cadNum)
  } catch (e) {
    return false
  }
}

/**
 * Площадь объекта
 * @param value
 * @returns {boolean}
 */
export const isSquareDecimalFormatValid = (value) => {
  try {
    if (!value)
      return true;

    if (value.includes('.')) {
      const regex = new RegExp(/^\d{1,}\.\d{1,2}$/, 'g');
      return regex.test(value);
    } else {
      const regex = new RegExp(/^\d{1,}$/, 'g');
      return regex.test(value);
    }
  } catch (e) {
    return false;
  }
}

/**
 * Стоимость объекта
 * @param value
 * @returns {boolean}
 */
export const isCostDecimalFormatValid = (value) => {
  try {
    if (!value)
      return true;

    if (value.includes('.')) {
      const regex = new RegExp(/^\d{1,}\.\d{1,2}$/, 'g');
      return regex.test(value);
    } else {
      const regex = new RegExp(/^\d{1,}$/, 'g');
      return regex.test(value);
    }
  } catch (e) {
    return false;
  }
}

/**
 * Адрес ФИАС Объекта недвижимости
 * @param adr - объект адрес
 * @returns {boolean}
 */
export const isRealtyFIASAddressValid = (adr) => {
  try {
    if(
      !adr.RegionKladrID ||
      !adr.Region ||
      !adr.Okato ||
      !adr.Oktmo ||
      !adr.FiasID
    ) return false

    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Проверка обязательных полей для РР адреса ФИАС
 * @param adr - объект адрес
 * @returns {boolean}
 */
export const isFIASAddressValid = (adr) => {
  try {
    if(
      !adr.RegionKladrID ||
      !adr.Region ||
      !adr.Okato ||
      !adr.Oktmo ||
      !adr.FiasID
    ) return false

    return true;
  } catch (e) {
    return false;
  }
}

export const isLastNameValid = (val) => {
  try {
    const regex = new RegExp(/^[А-ЯЁёа-я\s\-IV'`()]*$/, 'gu');
    return regex.test(val);
  } catch (e) {
    return false
  }
}

export const isMiddleNameValid = (val) => {
  try {
    if(!val)
      return true

    const regex = new RegExp(/^[А-ЯЁёа-я\s\-IV'`()]*$/, 'gu');
    return regex.test(val);
  } catch (e) {
    return false
  }
}

/**
 * Проверка СНИЛС
 * @returns {boolean}
 * @param snils
 */
export const isSnilsValid = (snils) => {
  try {
    // Убираем все нецифровые символы
    const cleanSnils = snils.replace(/\D/g, '');

    // Проверяем длину (должно быть 11 цифр)
    if (cleanSnils.length !== 11) {
      return false;
    }

    // Проверяем что все символы цифры
    if (!/^\d+$/.test(cleanSnils)) {
      return false;
    }

    // Извлекаем номер (первые 9 цифр) и контрольную сумму (последние 2 цифры)
    const numberPart = cleanSnils.substring(0, 9);
    const checksum = parseInt(cleanSnils.substring(9, 11), 10);

    // Особые случаи - контрольные числа больше 100 не проверяются
    if (checksum > 100) {
      return false;
    }

    // Вычисляем контрольную сумму
    let calculatedChecksum = 0;

    for (let i = 0; i < 9; i++) {
      const digit = parseInt(numberPart[i], 10);
      calculatedChecksum += digit * (9 - i);
    }

    // Корректируем контрольную сумму
    if (calculatedChecksum < 100) {
      return calculatedChecksum === checksum;
    } else if (calculatedChecksum === 100 || calculatedChecksum === 101) {
      return checksum === 0;
    } else {
      const remainder = calculatedChecksum % 101;
      if (remainder === 100) {
        return checksum === 0;
      } else {
        return remainder === checksum;
      }
    }
  } catch (e) {
    return false
  }
}

/**
 * Проверка Доли
 * @param share
 * @returns {boolean}
 */
export const isShareValid = (share) => {
  try {
    if (!share)
      return true;

    if (share.includes('/')) {
      return (new RegExp(/^\d+\/\d+$/, 'g')).test(share);
    } else {
      return (new RegExp(/^\d+$/, 'g')).test(share);
    }
  } catch (e) {
    return false
  }
}

/**
 * Проверка указания доли при выборе Общей долевой собственности
 * @param rightKind
 * @param share
 * @returns {boolean}
 */
export const isSharedOwnershipValid = (rightKind, share) => {
  try {
    if (rightKind !== 'sharedOwnership')
      return true;

    if(isEmpty(share))
      return false;

    return true;
  } catch (e) {
    return false
  }
}

/**
 * Проверка указания дол при выборе Общей долевой собственности
 * @returns {boolean}
 */
export const isRepresDocumentAttachedToParticipant = (person) => {
  try {
    if(!person.representativeDocumentId)
      return true

    if(!person.documentsRef)
      return false

    if(!person.documentsRef.includes(person.representativeDocumentId))
      return false

    return true;
  } catch (e) {
    return false
  }
}

/**
 * Проверка указан ли документ подтверждающий полномочия представителя
 * @returns {boolean}
 */
export const isRepresDocument = (person) => {
  try {
    if(!person.representativeId)
      return true

    if(!person.representativeDocumentId)
      return false

    return true;
  } catch (e) {
    return false
  }
}

/**
 * Проверка ИНН
 */
export const isINNValid = (inn, error) => {
  let result = true;
  if (typeof inn === 'number') {
    inn = inn.toString();
  } else if (typeof inn !== 'string') {
    inn = '';
  }

  if (/[^0-9]/.test(inn)) {
    result = false
  } else if ([10, 12].indexOf(inn.length) === -1) {
    result = false
  } else {
    const checkDigit = (inn, coefficients) => {
      var n = 0;
      for (var i in coefficients) {
        n += coefficients[i] * inn[i];
      }
      return parseInt(n % 11 % 10);
    };
    switch (inn.length) {
      case 10:
        const n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
        if (n10 !== parseInt(inn[9])) {
          result = false;
        }
        break;
      case 12:
        var n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
        var n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
        if ((n11 !== parseInt(inn[10])) && (n12 !== parseInt(inn[11]))) {
          result = false;
        }
        break;
    }
  }

  return result;
}

export const isRUPassportSeriesValid = (series) => {
  try {
    if(!series)
      return true

    const regex = new RegExp(/^.{1,40}$/, 'gu');
    return regex.test(series);
  } catch (e) {
    return false
  }
}

export const isRUPassportNumberValid = (number) => {
  try {
    if(!number)
      return true

    const regex = new RegExp(/^.{1,250}$/, 'gu');
    return regex.test(number);
  } catch (e) {
    return false
  }
}

export const isRUPassportDivisionCodeValid = (number) => {
  try {
    if(!number)
      return true

    const regex = new RegExp(/^\d{3}[-|\s]?\d{3}$/, 'gu');
    return regex.test(number);
  } catch (e) {
    return false
  }
}

/**
 * Проверяет прикреплен ли документ к заявителю
 * @param doc
 */
export const hasDocumentRefToParticipant = (doc) => {
  try {
    if(
      dealData?.documentsRefListToParticipants[doc.id] &&
      dealData?.documentsRefListToParticipants[doc.id].length
    )
      return true

    return false
  } catch (e) {
    return true;
  }
}

export let personDataError = {
  registrationFIASAddress: false,
  lastName: false,
  firstName: false,
  middleName: false,
  inn: false,
  phone: false,
  snils: false,
  series: false,
  number: false,
  issuer: false,
  divisionCode: false,
  share: false,
}

/**
 * Проверка данных физического лица
 * @param {Participant} participant
 * @param name
 * @returns {{registrationFIASAddress: boolean, lastName: boolean}}
 */
export const validatePersonData = (participant, name) => {
  if (!participant || participant.type === SubjectType.ORGANIZATION)
    return personDataError;

  if (!name || (name && name === 'addressData'))
    personDataError.registrationFIASAddress = !isFIASAddressValid(participant.addressData)

  if (!name || (name && name === 'birthDate'))
    personDataError.birthDate = isEmpty(participant.birthDate)

  if (!name || (name && name === 'lastName'))
    personDataError.lastName = isEmpty(participant.lastName) || !isLastNameValid(participant.lastName);

  if (!name || (name && name === 'firstName'))
    personDataError.firstName = isEmpty(participant.firstName) || !isLastNameValid(participant.firstName);

  if (!name || (name && name === 'phone'))
    personDataError.phone = isEmpty(participant.phone)

  if (!name || (name && name === 'middleName'))
    personDataError.middleName = !isMiddleNameValid(participant.middleName);

  if (!name || (name && name === 'snils'))
    personDataError.snils = !isSnilsValid(participant.snils);

  if (!name || (name && name === 'inn'))
    personDataError.inn = !isINNValid(participant.inn);

  if (!name || (name && name === 'series') && participant.IDDocumentType === 'passport')
    personDataError.series = !isRUPassportSeriesValid(participant.series);

  if (!name || (name && name === 'number') && participant.IDDocumentType === 'passport')
    personDataError.number = !isRUPassportNumberValid(participant.number);

  if (!name || (name && name === 'issuer') && participant.IDDocumentType === 'passport')
    personDataError.issuer = isEmpty(participant.issuer);

  if (!name || (name && name === 'divisionCode') && participant.IDDocumentType === 'passport')
    personDataError.divisionCode = !isRUPassportDivisionCodeValid(participant.divisionCode);


  return personDataError;
}

export let optionalParticipantErrors = {
  share: false,
  sharedOwnership: false,
  represDocSetToParticipant: false,
  represDocumentAttachToParticipant: false,
}

export const validateOptionalParticipantElements = (person, name) => {
  if (!name || (name && name === 'share'))
    optionalParticipantErrors.share = !isShareValid(person.share);
  // проверка указания доли при выбранной Общей долевой собственности
  if (!name || (name && name === 'sharedOwnership' && !optionalParticipantErrors.share))
    optionalParticipantErrors.sharedOwnership = !isSharedOwnershipValid(person.rightKind, person.share);
  // проверка приложен ли документ уполномачивающий представителя к заявителю
  if (!name || (name && name === 'representativeDocumentId' && !optionalParticipantErrors.represDocSetToParticipant))
    optionalParticipantErrors.represDocumentAttachToParticipant = !isRepresDocumentAttachedToParticipant(person);
  // проверка указан ли документ уполномачивающий представителя
  if (!name || (name && name === 'representativeId'))
    optionalParticipantErrors.represDocSetToParticipant = !isRepresDocument(person);

  return optionalParticipantErrors;
}

export const participantsErrors = new Map();

/**
 * Есть ли у заявителя ошибки в пуле ошибок
 */
export const hasParticipantsError = (participantId) => {
  const errors = participantsErrors.get(participantId);

  if (errors) {
    return Object.values(errors).includes(true)
  }

  return false;
}